import React from "react";
import ConverterForm from "./components/ConverterForm";

function App() {
  return <ConverterForm />;
}

export default App;
